import { IInstallmentsLink } from "../interfaces";
import InstallmentsModel from "./InstallmentsModel";

class InstallmentsLinkModel<T extends InstallmentsModel> {
  private _links: IInstallmentsLink<T>[] = [];

  get links(): IInstallmentsLink<T>[] {
    return [...this._links];
  }

  addLink(target: T, installmentId: number) {
    if (target) {
      this._links.push({
        target,
        installments: [installmentId],
      });
    }
  }

  addInstallmentId(link: IInstallmentsLink<T>, installmentId: number) {
    const installmentFound = link.installments.find(
      (installment) => installment === installmentId
    );

    if (!installmentFound) {
      link.installments.push(installmentId);
    }
  }

  clear() {
    this._links = [];
  }

  findLink(id: string): IInstallmentsLink<T> | undefined {
    return this._links.find((link: any) => link.target.uid === id);
  }

  removeItem(targetId: string, installmentId: number) {
    const targetFound = this.findLink(targetId);
    if (targetFound) {
      const newInstallments = targetFound.installments.filter(
        (e) => e !== installmentId
      );
      targetFound.installments = newInstallments;
    }
  }

  static expandList(links: IInstallmentsLink<any>[]): {
    target: any;
    installment: number;
    value: number;
  }[] {
    const listExpanded: any[] = [];

    for (const link of links) {
      const { target, installments } = link;

      for (const installmentUid of installments) {
        const installment = target.installments.find(
          (installment) => installment.id === installmentUid
        );

        if (installment) {
          listExpanded.push({
            target,
            installment: installmentUid,
            value: installment.value,
          });
        }
      }
    }

    return listExpanded;
  }
}

export default InstallmentsLinkModel;
